var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cellInfo.type !== 'template')?_c(_vm.currCell,{tag:"component",attrs:{"cell-data":_vm.cellInfo,"doc-data":_vm.docData}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }